module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"requiredField":"Обязательное поле для заполнения","finishTest":"Закончить тестирование","enterTheAnswer":"Введите ответ"}}')
  delete Component.options._Ctor
}
